import { Injectable } from '@angular/core';

import { SPAConfigurationService } from 'shared/services/spa-configuration.service';
import { SharedConfiguration } from 'shared/shared.config';


@Injectable()
export class SharedConfigurationService extends SPAConfigurationService<SharedConfiguration> {

}
